import { render } from "./PerksUser.vue?vue&type=template&id=4eeaec14"
import script from "./PerksUser.vue?vue&type=script&lang=js"
export * from "./PerksUser.vue?vue&type=script&lang=js"

import "./PerksUser.vue?vue&type=style&index=0&id=4eeaec14&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__